module.exports = __webpack_public_path__ + "static/corporate-a0d9f606bc8d7d28aa32a52504e08cfa.jpg";